import React from 'react';
import PropTypes from 'prop-types';

const SelectItem = props => (
  <div className="lr-customer-pop lr-lang-pop-custom">
    <div className="lr-customer-pop__modal lr-pop__language">
      {
        props.showCloseButton &&
        <button type="button" className="lr-language__Close-button" onClick={props.onClose} />
      }
      <h2 className={`lr-languageSelect-heading ${props.headerProminent && 'lr-language__heading-backround'}`}>
        {props.heading}
      </h2>
      <div className="lr-select-product-pop-scroll">
        <div className="lr-languageSelect__container">
          {
            props.options.length > 0 && props.options.map(option => (
              <div
                key={option.value}
                onClick={() => {
                  if (props.selectedOptVal === option.value) {
                    return false;
                  }
                  props.onSelect(option.value);
                  return true;
                }}
                className={`lr-languageSelect__container__List ${props.selectedOptVal === option.value ? 'active' : ''}`}
              >
                {option.text}
              </div>
            ))
          }
        </div>
      </div>
    </div>
  </div>
);

SelectItem.propTypes = {
  options: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  onSelect: PropTypes.func.isRequired,
  onClose: PropTypes.func,
  showCloseButton: PropTypes.bool,
  selectedOptVal: PropTypes.node,
  heading: PropTypes.node.isRequired,
  headerProminent: PropTypes.bool,
};

SelectItem.defaultProps = {
  selectedOptVal: undefined,
  onClose: () => {},
  headerProminent: false,
  showCloseButton: false,
};

export default SelectItem;
